export default "__VITE_ASSET__D2lbj0za__"